export default {
  presets: {
    light: {
      backgroundPrimary: '#F4F6F8',
      backgroundSecondary: '#FFFFFF',
      backgroundCardPrimary: '#F7F9F9',
      backgroundCardSecondary: '#ECFDE6',
      success: '#228200',
      info: '#158DE3',
      danger: '#E42222',
      warning: '#FFD43A',
    },
    dark: {
      backgroundPrimary: '#0F172A',
      backgroundSecondary: '#1E293B',
      backgroundCardPrimary: '#1E293B',
      backgroundCardSecondary: '#0f4c3a',
      success: '#10B981',
      info: '#3B82F6',
      danger: '#EF4444',
      warning: '#F59E0B',
    },
  },
}
